import { useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

export default function Switch({
  value,
  onChange,
  onText,
  offText,
  className
}) {
  const elm = useRef(null);
  const [state, setState] = useState(value ?? true);

  const handleOnChange = (newValue) => {
    setState(newValue);
    onChange?.(elm.current, newValue);
  };

  return (
    <ButtonGroup ref={elm} size="sm" className={className}>
      <Button
        variant={state ? "success" : "outline-secondary"}
        onClick={() => handleOnChange(true)}
      >
        {onText ?? "ON"}
      </Button>
      <Button
        variant={state ? "outline-secondary" : "success"}
        onClick={() => handleOnChange(false)}
      >
        {offText ?? "OFF"}
      </Button>
    </ButtonGroup>
  );
}
